import { SET_GLOBAL_ERROR } from './actionTypes'

const setGlobalError = (payload) => ({
  type: SET_GLOBAL_ERROR,
  payload
})

export default setGlobalError;
